<div class="hide-up-container"
     [elementHeight]="'promo-bar'">
    <div class="ng-hide-animate hide-up"
         [class.ng-hide-animate]="canAnimate"
         [class.ng-hide]="hidden">
        <ng-container [ngSwitch]="data.promobarItemType">
            <div [ngClass]="[data.promobar_color || 'col-1', (data.promobarItemType === 'expandable') ? 'cursor-pointer' : '']"
                 [zippyToggle]="data.promobarItemType === 'expandable' ? 'special-menu' : ''"
                 [style]="backgroundColors">
                <div class="flex">
                    <div
                         class="pos-relative w-12 flex flex-middle flex-justify-center p-r-6-x p-l-6-x center _promobar-content">
                        <!-- content -->
                        <ng-container *ngSwitchCase="'text_or_link'">
                            <href [link]="data.promobar_link">
                                <div sizeClass="!S: p1, S: p2"
                                     [ngClass]="[data.promobar_color || 'col-1']"
                                     *iCms="'promobar_text' of data; content: 'html'"></div>
                            </href>
                        </ng-container>
                        <!-- expandable -->
                        <ng-container *ngSwitchCase="'expandable'">
                            <div class="p-l p-r p-t-1 p-b-1 flex">
                                <!-- invisible icon to add equal space -->
                                <div class="m-l-2">
                                    <i class="icon-chevron-right col-t"
                                       aria-hidden="true"></i>
                                </div>
                                <href [link]="data.promobar_link">
                                    <div [sizeClass]="'!S: p1, S: p2'"
                                         [ngClass]="[data.promobar_color || 'col-1']"
                                         *iCms="'promobar_text' of data; content: 'html'"></div>
                                </href>
                                <button class="cursor-pointer inline-flex flex-middle m-l-2"
                                        type="button"
                                        [ngClass]="[data.promobar_color || 'col-1']"
                                        [attr.aria-label]="'expand' | translate">
                                    <i class="icon-chevron-right rotate-90 inline-flex"
                                       [zippyClass]="'rotate-180'"
                                       [zippyName]="'special-menu'"
                                       aria-hidden="true"></i>
                                </button>
                            </div>
                        </ng-container>
                        <!-- countdown -->
                        <ng-container>
                            <ng-container *ngSwitchCase="'countdown'">
                                <ng-container>
                                    <countdown class="flex-x flex-l flex-middle m-r-10-x m-r-10-l"
                                               *ngSwitchCase="'countdown'"
                                               [date]="getUkDate(data.promobarEndDate, data.promobarEndTime)"
                                               [whitelist]="['days', 'hours', 'minutes', 'seconds']"
                                               [shouldPad]="true">
                                        <ng-template #countdownTemplate
                                                     let-result>

                                            <!-- content after countdown -->
                                            <ng-container
                                                          *ngIf="!result.score?.days && !result.score?.hours && !result.score?.minutes && !result.score?.seconds">
                                                <div sizeClass="MS:h5,XL:h3"
                                                     class="m-r-2"
                                                     [ngClass]="[data.promobar_color || 'col-1']"
                                                     *iCms="'promobarTextAfterCountdown' of data; content: 'html'">
                                                </div>

                                                <ng-container
                                                              *ngIf="data.promobarCtaTextAfterCountdown && data.promobarCtaLinkAfterCountdown">
                                                    <href *ifSize="'XL'"
                                                          class="_custom-button p1 b-a m-l-10"
                                                          [ngClass]="[data.promobar_color || 'col-1', 'b-' + data.promobar_color]"
                                                          [link]="data.promobarCtaLinkAfterCountdown">
                                                        <span *iCms="'promobarCtaTextAfterCountdown' of data"></span>
                                                    </href>

                                                    <ng-container *ifSize="'MS'">
                                                        <href [link]="data.promobarCtaLinkAfterCountdown">
                                                            <button class="_mobile-button p3 underline"
                                                                    [ngClass]="[data.promobar_color || 'col-1']"
                                                                    *iCms="'promobarCtaTextAfterCountdown' of data"></button>
                                                        </href>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>

                                            <!-- content during countdown -->
                                            <ng-container
                                                          *ngIf="result.score?.days || result.score?.hours || result.score?.minutes || result.score?.seconds">
                                                <div class="m-r-4-x m-r-4-l col-w"
                                                     sizeClass="MS:h5,XL:h3"
                                                     *iCms="'promobarCountdownText' of data; content: 'html'"></div>
                                                <div class="flex-m flex-s">
                                                    <ng-container *ngIf="result.score?.seconds">
                                                        <span class="m-l-1-m m-l-1-s m-t-2-m m-t-2-s">
                                                            <ng-container
                                                                          *ngIf="result.score?.days > 1 && result.score?.days < 10">
                                                                <span class="_custom-date m-r-1 m-r-2-m m-r-2-s m-l-5-x m-l-5-l p1 p-r-2 p-l-2 col-1 bg-col-w"
                                                                      sizeClass="MS:p3,XL:p1">
                                                                    0{{result.score.days}}</span><span
                                                                      sizeClass="MS:p3 m-r-3,XL:c1">{{'' |
                                                                    translate}}days</span>
                                                            </ng-container>
                                                            <ng-container *ngIf="result.score?.days >= 10">
                                                                <span class="_custom-date m-r-1 m-r-2-m m-r-2-s m-l-5-x m-l-5-l p1 p-r-2 p-l-2 col-1 bg-col-w"
                                                                      sizeClass="MS:p3,XL:p1">
                                                                    {{result.score.days}}</span><span
                                                                      sizeClass="MS:p3 m-r-3,XL:c1">{{'' |
                                                                    translate}}days</span>
                                                            </ng-container>
                                                            <ng-container *ngIf="result.score?.days == 1">
                                                                <span class="_custom-date m-r-1 m-r-2-m m-r-2-s m-l-5-x m-l-5-l p1 p-r-2 p-l-2 col-1 bg-col-w"
                                                                      sizeClass="MS:p3,XL:p1">0{{result.score.days}}</span><span
                                                                      sizeClass="MS:p3 m-r-3,XL:c1">{{'' |
                                                                    translate}}day</span>
                                                            </ng-container>
                                                            <ng-container *ngIf="result.score?.days == 0">
                                                                <span class="_custom-date m-r-1 m-r-2-m m-r-2-s m-l-5-x m-l-5-l p1 p-r-2 p-l-2 col-1 bg-col-w"
                                                                      sizeClass="MS:p3,XL:p1">00</span>
                                                                <span sizeClass="MS:p3 m-r-3,XL:c1">{{'' |
                                                                    translate}}days</span>
                                                            </ng-container>
                                                            <span class="_custom-date m-r-1 m-r-2-m m-r-2-s m-l-5-x m-l-5-l p1 p-r-2 p-l-2 col-1 bg-col-w"
                                                                  sizeClass="MS:p3,XL:p1">{{
                                                                result.score?.hours}}</span><span
                                                                  sizeClass="MS:p3 m-r-3,XL:c1">{{'' |
                                                                translate}}hrs</span>
                                                            <span class="_custom-date m-r-1 m-r-2-m m-r-2-s m-l-5-x m-l-5-l p1 p-r-2 p-l-2 col-1 bg-col-w"
                                                                  sizeClass="MS:p3,XL:p1">{{
                                                                result.score?.minutes}}</span><span
                                                                  sizeClass="MS:p3 m-r-3,XL:c1">{{'' |
                                                                translate}}mins</span>
                                                            <span class="_custom-date m-r-1 m-r-2-m m-r-2-s m-l-5-x m-l-5-l p1 p-r-2 p-l-2 col-1 bg-col-w"
                                                                  sizeClass="MS:p3,XL:p1">{{
                                                                result.score?.seconds}}</span><span
                                                                  sizeClass="MS:p3 m-r-3,XL:c1">{{'' |
                                                                translate}}secs</span>
                                                        </span>
                                                    </ng-container>

                                                    <ng-container *ngIf="data.promobarCtaText && data.promobarCtaLink">
                                                        <href *ifSize="'XL'"
                                                              class="_custom-button p1 b-a m-l-10"
                                                              [ngClass]="[data.promobar_color || 'col-1', 'b-' + data.promobar_color]"
                                                              [link]="data.promobarCtaLink">
                                                            <span *iCms="'promobarCtaText' of data"></span>
                                                        </href>
                                                        <ng-container *ifSize="'MS'">
                                                            <href [link]="data.promobarCtaLink">
                                                                <button class="_mobile-button p3 underline"
                                                                        [ngClass]="[data.promobar_color || 'col-1']"
                                                                        *iCms="'promobarCtaText' of data"></button>
                                                            </href>
                                                        </ng-container>
                                                    </ng-container>
                                                </div>
                                            </ng-container>
                                        </ng-template>
                                    </countdown>
                                </ng-container>
                            </ng-container>
                        </ng-container>

                        <!-- close -->
                        <button class="_custom-close pos-absolute z-1 cursor-pointer inline-flex flex-middle"
                                type="button"
                                [attr.aria-label]="'Close' | translate"
                                [ngClass]="[data.promobar_color || 'col-1']"
                                (click)="close()"
                                *ngIf="data.promobar_closeable && data.promobarItemType !== 'expandable'">
                            <i class="_custom-icon icon-close inline-flex"
                               aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div [zippyHideUp]="'special-menu'">
                <special-menu [data]="data"></special-menu>
            </div>
        </ng-container>
    </div>
</div>